import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingComponent } from './landing/landing.component';
import { BillComponent } from './bill/bill.component';
import { OrderConfirmationComponent } from './order-confirmation/order-confirmation.component';
import { BillPaidComponent } from './bill-paid/bill-paid.component';
import { LanguageSelectionComponent } from './language-selection/language-selection.component';
import { PaymentPageComponent } from './pay-at-table/payments/payments';
import { SplitPaymentPageComponent } from './pay-at-table/split-payment/split-payment';
import { MenuHomeComponent } from './menu/home-page/menu-home/menu-home.component';
import { MenuListComponent } from './menu/list-page/menu-list/menu-list.component';
import { CartComponent } from './cart/cart.component';
import { AdyenComponent } from './self-checkout/adyen/adyen.component';
import { GeideaComponent } from './self-checkout/geidea/geidea.component';
import { CheckoutV2Component } from './self-checkout/checkout-v2/checkout-v2.component';
import { QRScanComponent } from './qrscan/qrscan.component';
import { CybersourceComponent } from './self-checkout/cybersource/cybersource.component';
import { menuHomeGuard } from './menu/menu-home.guard';
import { languageSelectionGuard } from './language-selection/language-selection.guard';
import { orderingEnabledGuard } from './cart/ordering-enabled.guard';

const appRoutes: Routes = [
  // keep it as is because the links to all restaurant redirect to this /menu route
  { path: '', redirectTo: 'menu', pathMatch: 'full' },
  { path: 'menu', component: LandingComponent, canActivate: [languageSelectionGuard] },
  { path: 'menu-home', component: MenuHomeComponent, canActivate: [languageSelectionGuard, menuHomeGuard] },
  { path: 'menu-list/:superSectionId', component: MenuListComponent, canActivate: [languageSelectionGuard] },
  { path: 'cart', component: CartComponent, canActivate: [languageSelectionGuard, orderingEnabledGuard] },
  { path: 'bill', component: BillComponent, canActivate: [languageSelectionGuard] },
  { path: 'confirm-order', component: OrderConfirmationComponent },
  { path: 'bill-paid', component: BillPaidComponent },
  { path: 'select-language', component: LanguageSelectionComponent },
  { path: 'pay-at-table', component: PaymentPageComponent, canActivate: [languageSelectionGuard] },
  { path: 'pay-at-table/split', component: SplitPaymentPageComponent, canActivate: [languageSelectionGuard] },
  { path: 'payment/adyen', component: AdyenComponent },
  { path: 'payment/geidea', component: GeideaComponent },
  { path: 'payment/checkout-v2', component: CheckoutV2Component },
  { path: 'rescan', component: QRScanComponent },
  { path: 'payment/cybersource', component: CybersourceComponent },

  // catches anything unmatched (e.g. /menu-list with no id) instead of throwing NG04002 to a blank screen
  { path: '**', redirectTo: 'menu' },
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(
      appRoutes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      bindToComponentInputs: true,
    }
    ),
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
